<template>
  <div class="modal fade" id="yamato-shipping-info-modal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog" @click.stop>
      <div class="modal-content">
        <div class="modal-body">
          <div class="yamato-shipping-table">
            <div class="yamato-shipping-table-wrap" v-html="shippingInfoTable"></div>
            <div class="text-center text--underline mr-t-15">
              <a :href="yamatoCardboardSizeUrl" target="_blank">各サイズの大きさ、重さについては、こちらをご参照ください。</a>
            </div>
            <div class="mr-t-15 text-center">
              <button type="button" class="btn m-w-120" data-dismiss="modal" @click="$emit('close')">閉じる</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shippingInfoTable: {
      type: String,
      default: ''
    }
  },
  computed: {
    yamatoCardboardSizeUrl () {
      return 'https://image-yoshino.sakura.ne.jp/monster/documents/YamatoCardboardSize.png'
    }
  },
  mounted () {
    $('#yamato-shipping-info-modal').modal('show')
    $(window).resize(() => {
      let screenWidth = $(window).width()
      if (screenWidth <= 650) {
        $('.yamato-shipping-table-wrap .table').css({
          'width': 'max-content',
          'max-width': 'max-content'
        })
      } else {
        $('.yamato-shipping-table-wrap .table').css({
          'width': '98%',
          'max-width': 'unset'
        })
      }
    })
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>

<style scoped>
@media (max-width: 650px) {
  .yamato-shipping-table-wrap {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
   }
}
</style>



// WEBPACK FOOTER //
// src/components/YamatoShippingInfoModal.vue